import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Button } from '../../../../../components-v2/Button';

interface ReorderQuestionsButtonProps {
	onReorderQuestions: () => void;
	hasMultipleQuestions: boolean;
	isLoading?: boolean;
	styles?: StyleSheet[];
	inline?: boolean;
}

export const ReorderQuestionsButton: React.FC<ReorderQuestionsButtonProps> = ({
	onReorderQuestions,
	hasMultipleQuestions,
	isLoading = false,
	styles = [],
	inline = false,
}) => {
	if (!hasMultipleQuestions) {
		return null;
	}

	return (
		<div className={css(inline ? styleSheet.containerInline : styleSheet.container, ...styles)}>
			<Button
				type='button'
				variant='secondary'
				onClick={onReorderQuestions}
				disabled={isLoading}
				styles={styles}
				data-testid='reorder-questions-btn'
			>
				Reorder Questions
			</Button>
		</div>
	);
};

const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginBottom: 16,
		paddingRight: 16,
		position: 'absolute',
		right: 0,
		top: 0,
		zIndex: 1,
	},
	// In-flow variant used when the button is hosted inside an external positioned
	// container (e.g. CustomSurvey's sticky reorder gutter) rather than overlaying the form.
	containerInline: {
		display: 'flex',
	},
});
